import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class UuidService {
    static empty = '00000000-0000-0000-0000-000000000000';

    static generate(): string {
        return uuidv4();
    }

    generate(): string {
        return UuidService.generate();
    }

    isEmpty(uuid: string) {
        if (!uuid) {
            return true;
        }
        if (uuid?.trim() === '') {
            return true;
        }

        return uuid === UuidService.empty;
    }

    isUuid(uuid: string) {
        const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return pattern.test(uuid);
    }
}
